import React from 'react';
import ReactDOM from 'react-dom';
import ToastComponent from './toast';

interface IToastOptions {
  duration?: number; // 显示时间长度， 默认3s。
  message?: string;
  classNames?: string; // 附加的class样式
  maskClassName?: string; // 附加的遮罩层class样式
  icon?: string;
}

export default class Toast {
  static timer: ReturnType<typeof setTimeout> | null;

  static $toastContainer: HTMLDivElement | null;

  /* 显示Toast */
  static show(msg: string, options: IToastOptions = {}): void {
    if (this.$toastContainer) {
      this.hide();
    }
    const message = msg || options.message || 'toast';
    const { classNames, duration = 3000, icon, maskClassName } = options;
    const $toastContainer = document.createElement('div');
    this.$toastContainer = $toastContainer;
    document.body.appendChild($toastContainer);
    ReactDOM.render(
      <ToastComponent
        text={message}
        classNames={classNames}
        icon={icon}
        maskClassName={maskClassName}
      />,
      $toastContainer,
    );

    if (duration) {
      this.timer = setTimeout(() => this.hide(), duration);
    }
  }

  /* 隐藏toast */
  static hide(): void {
    const { timer, $toastContainer } = this;
    if (timer) {
      clearTimeout(timer);
      this.timer = null;
    }
    if ($toastContainer && $toastContainer.parentNode === document.body) {
      document.body.removeChild($toastContainer);
      this.$toastContainer = null;
    }
  }

  static showError(e: Error | string | any, options: IToastOptions = {}): void {
    if (!e) {
      return;
    }
    if (typeof e === 'string') {
      Toast.show(e, options);
      return;
    }
    Toast.show(
      e.message || e.msg || e.errMessage || '网络开小差了，请重新试试',
      options,
    );
    // eslint-disable-next-line no-console
    console.error(e);
  }

  static showInfo(msg: string, options: IToastOptions = {}): void {
    Toast.show(msg, options);
  }
}
